var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M5.906-7.344a.244.244,0,0,1,0-.172.367.367,0,0,1,.078-.125.367.367,0,0,1,.125-.078.459.459,0,0,1,.172-.031H7.719a.374.374,0,0,1,.3.125.314.314,0,0,1,.078.281l-.187,3.25a.337.337,0,0,1-.375.344H6.469a.337.337,0,0,1-.375-.344ZM7.891-2.891A1.209,1.209,0,0,1,8.25-2a1.209,1.209,0,0,1-.359.891A1.209,1.209,0,0,1,7-.75a1.209,1.209,0,0,1-.891-.359A1.209,1.209,0,0,1,5.75-2a1.209,1.209,0,0,1,.359-.891A1.209,1.209,0,0,1,7-3.25,1.209,1.209,0,0,1,7.891-2.891ZM12.5-12a1.447,1.447,0,0,1,1.063.438A1.447,1.447,0,0,1,14-10.5V.5a1.447,1.447,0,0,1-.437,1.063A1.447,1.447,0,0,1,12.5,2H1.5A1.447,1.447,0,0,1,.438,1.563,1.447,1.447,0,0,1,0,.5v-11a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-12H3v-1.625A.331.331,0,0,1,3.375-14h1.25A.331.331,0,0,1,5-13.625V-12H9v-1.625A.331.331,0,0,1,9.375-14h1.25a.331.331,0,0,1,.375.375V-12ZM12.313.5A.166.166,0,0,0,12.5.313V-9H1.5V.313A.166.166,0,0,0,1.688.5Z",
    transform: "translate(0 14)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.6b00262919ea07c975a377ce7d887e28.svg";
export { ForwardRef as ReactComponent };